var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol-page"},[_c('div',{staticClass:"protocol-container"},[_c('div',{staticClass:"protocol-content markdown-body",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }